module.exports = __webpack_public_path__ + "img/front_neck_depth.56888d3e.png";